// src/pages/appointments/details/AppointmentDeleteDialog.jsx
import React from "react";
import ReactDOM from "react-dom";

export default function AppointmentDeleteDialog({
  open,
  title = "Are you sure you want to delete this medical appointment?",
  description = "After deleting the medical appointment record, you will not be able to recover it.",
  cancelText = "No",
  confirmText = "Delete",
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      {/* Backdrop */}
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
        aria-label="Close dialog"
      />

      {/* Card */}
      <div
        className="
          relative w-[min(520px,calc(100vw-32px))]
          rounded-[20px]
          bg-[rgb(var(--clr-surface-cont-highest))]
          shadow-[0_10px_30px_rgba(15,23,42,0.20)]
          px-6 pt-6 pb-5
        "
      >
        <div className="text-headline-small text-on-surface">{title}</div>

        <div className="mt-2 text-body-medium text-on-surface-var">{description}</div>

        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="
              flex-1 h-12 rounded-[12px]
                bg-[var(--state-on-surface-08)]
                text-[rgb(var(--afrimed-primary))]
                text-label-large
            "
          >
            {cancelText}
          </button>

          <button
            type="button"
            onClick={onConfirm}
            className="
              flex-1 h-12 rounded-[12px]
                bg-[var(--state-critical-08)]
                text-[rgb(var(--schemes-critical))]
                text-label-large
            "
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}